import { ReactNode } from 'react';
import { VoyagersClubAlreadyAMemberProps } from '@msc-b2c/interfaces/types';
import AlreadyMemberLayout from './AlreadyMemberLayout';

export function VoyagersClubAlreadyMemberWrapper(
  props: Readonly<VoyagersClubAlreadyAMemberProps>
): ReactNode {
  return <AlreadyMemberLayout {...props} />;
}

export default VoyagersClubAlreadyMemberWrapper;

VoyagersClubAlreadyMemberWrapper.aemResourceType =
  'b2c-website-foundation/components/mymsc/voyagersclubalreadyamember';
